export * as manual from './manual'
export * as inherit from './inherit'
export * as salary from './salary'
